import './style.scss';
import 'swiper/swiper.scss';
import Swiper from "swiper";
import { Navigation, Autoplay } from 'swiper/modules';

export function related_treatments_block() {

    const blocks = document.querySelectorAll('.related_treatments_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {

        const swiperContainer = block.querySelector('.treatments-swiper');
        if (!swiperContainer) return;

        const nextBtn = block.querySelector('.swiper-button-next');
        const prevBtn = block.querySelector('.swiper-button-prev');

        const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;

        const hideNav = () => {
            if (nextBtn) nextBtn.style.display = "none";
            if (prevBtn) prevBtn.style.display = "none";
        };

        const w = window.innerWidth;

        if (w >= 1440 && slideCount <= 4) hideNav();
        else if (w >= 992 && w < 1440 && slideCount <= 3) hideNav();
        else if (w >= 768 && w < 992 && slideCount <= 2) hideNav();
        else if (w < 768 && slideCount <= 1) hideNav();

        new Swiper(swiperContainer, {
            slidesPerView: 1.152,
            spaceBetween: 24,
            slidesOffsetAfter: 44,
            speed: 500,
            loop: true,          
            breakpoints: {
                768: {slidesPerView: 2.206},
                992: {slidesPerView: 3.09},
                1024: {slidesPerView: 2.95},
                1280: {slidesPerView: 3.79},
                1440: {slidesPerView: 4.12},
                1920: {slidesPerView: 4.5},
            },

            modules: [Navigation, Autoplay],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            autoplay: {
                //delay: 3000,
            },
        });

    });
}
